import { HttpContextToken } from '@angular/common/http';

export const BYPASS_CHAIN_PARTY_INTERCEPTOR = new HttpContextToken<boolean>(() => false);
